import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'utils/baseQuery';
import { METHODS } from 'config';

interface PublicCalendarQuery {
  date: string;
}

interface UserOnLeave {
  userId: string;
  firstName: string;
  lastName: string;
  job: string;
  leaveType: number;
}

interface PublicCalendarResponse {
  date: string;
  totalOnLeave: number;
  users: UserOnLeave[];
}

const PublicCalendarApi = createApi({
  reducerPath: 'public-calendar-api',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    publicCalendar: builder.query<PublicCalendarResponse, PublicCalendarQuery>({
      query: (body) => ({
        url: '/dashboard/public-calendar',
        method: METHODS.post,
        body,
      }),
    }),
  }),
});

export const { usePublicCalendarQuery } = PublicCalendarApi;
export { PublicCalendarApi };
